import ApiService from '../apiservice'

export default class FaseService extends ApiService {
  constructor() {
    super('/rito')
  }

  cadastrar(rito) {
    return this.post('/',rito);
  }

  listar(empresa) {
    return this.get(`/${empresa}`);
  }

  consultar(codigo) {
    return this.get(`/porCodigo/${codigo}`);
  }

  alterar(rito) {
    return this.put(`/${rito.codigo}`,rito);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }
}